<template>
  <div>
    <el-form ref="formRef" :model="userForm" label-width="140px">
      <el-form-item label="头像：">
        <el-image style="width: 80px; height: 80px" :src="userForm.headImg.smallHeadImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      </el-form-item>
      <el-form-item label="信息：">
        <div class="item-info">
          <UserInfoList :row="userForm" showList="name,phone,uid,city,birth"/>
          <p>身高：{{ userForm.height }}cm</p>
          <p>达人状态：{{userForm.talentStatus == 0?'未提交':userForm.talentStatus == 1?'待审核':userForm.talentStatus == 2?'已通过':userForm.talentStatus == 3?'不通过':''}}</p>
        </div>
      </el-form-item>
<!--      <el-form-item label="状态：">-->
<!--        <div class="item-info">-->
<!--          <p>真人认证状态：{{userForm.baiduMatchState == 0?'未认证':userForm.baiduMatchState == 1?'已认证':userForm.baiduMatchState == 2?'认证失败':''}}</p>-->
<!--          <p>实名认证：{{userForm.baiduAuthState == 0?'未认证':userForm.baiduAuthState == 1?userForm.baiduAuth.certCode:userForm.baiduAuthState == 2?'认证失败':''}}</p>-->
<!--          <p>信息审核状态：{{userForm.resumeState == 0?'未提交':userForm.resumeState == 1?'待审核':userForm.resumeState == 2?'审核通过':userForm.resumeState == 3?'审核不通过':''}}</p>-->
<!--        </div>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="积分余额：">发送申请达人的小助手通知</el-form-item>-->
      <div style="text-align: center; margin: 24px 0">“提交（需申请）”会发送申请达人的小助手通知</div>
      <div class="dialog-footer" style="text-align: center; margin-bottom: 24px">
<!--        <el-button @click.native="cancel" >取消</el-button>-->
<!--        <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>-->
        <el-button style="margin-right: 24px" type="primary" @click="submit(1)" v-loading="loading">提交（需申请）</el-button>
        <el-button type="success" @click="submit(2)" v-loading="loading">确定（无需申请）</el-button>
      </div>
    </el-form>

  </div>
</template>

<script>
import {getFormData} from "@/api/api";
import {sendApplyNotify} from "@/api/url";

export default {
  name: "ApplySearchInfoDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userForm: this.value.userForm,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    submit(type) {
      this.loading = true
      let param = {}
      param['id'] = this.userForm.userId
      param['type'] = type
      getFormData(sendApplyNotify, param).then((data) => {
        let {code, msg} = data
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm')
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.item-info {
  margin-top: 4px;
}
.item-info p {
  line-height: 24px;
}
</style>
